let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2DxXe")).then(() => parcelRequire('9cwPn'));